module.exports = __webpack_public_path__ + "static/media/150.597dc671.png";